export const BOXERS = {
    male: {
        id: "player-male",
        name: "Bruiser Buckee",
        rank: 0,
        description: "Cold Soldier of Slugging",
        hp: 50,
        age: 25,
        weight: 175,
        wins: 0,
        losses: 0,
        kos: 0,
        tkos: 0,
        portraitTone: "male",
        sayings: [
            "I think he's bluffing.  Peg him in the stomach and make him fold.",
            "C'mon Pip, his face has no value. Deck him!",
            "He's playing wild.  Don't follow suit.",
            "Win, lose, or draw? Nah, there's only drawing and winning, kid!"
        ]
    },
    female: {
        id: "player-female",
        name: "Scamp Vixen [COMING SOON]",
        description: "Lover of Aggression",
        hp: 50,
        age: 25,
        weight: 175,
        wins: 0,
        losses: 0,
        kos: 0,
        tkos: 0,
        portraitTone: "female",
        sayings: [
            "Yer holding all the cards, Pip.  Make 'em count &mdash; to 10!",
            "She's playing wild.  Don't follow suit.",
            "C'mon Pip, her face has no value. Deck her!",
            "Win, lose, or draw? Nah, there's only drawing and winning, kid!"
        ]
    }
};
